import React, { useState } from 'react';
import { CustomSlider } from './CustomSlider';
export function PortfolioFit() {
  const [riskTolerance, setRiskTolerance] = useState(2);
  const [timeHorizon, setTimeHorizon] = useState(3);
  const getVerdict = () => {
    const riskLabels = ['very conservative', 'conservative', 'moderate', 'aggressive', 'very aggressive'];
    const timeLabels = ['short-term', 'medium-term', 'long-term', 'very long-term'];
    if (timeHorizon >= 2 && riskTolerance >= 1 && riskTolerance <= 3) {
      return `Good fit for a ${riskLabels[riskTolerance]}, ${timeLabels[timeHorizon]} investor.`;
    } else if (timeHorizon < 2) {
      return 'Consider a longer time horizon for tech stocks like AAPL.';
    } else if (riskTolerance === 0) {
      return 'AAPL might be too volatile for very conservative investors.';
    } else {
      return `Suitable for ${riskLabels[riskTolerance]} investors with a ${timeLabels[timeHorizon]} outlook.`;
    }
  };
  return <div className="bg-zinc-900 rounded-lg border border-zinc-800 p-6 mb-8" data-id="element-27">
      <h3 className="text-2xl font-semibold text-zinc-50 mb-6" style={{
      fontFamily: "'Instrument Serif', serif"
    }} data-id="element-28">
        Does this fit your portfolio?
      </h3>

      <div className="space-y-6 mb-6" data-id="element-29">
        <CustomSlider label="Risk tolerance" options={['Conservative', 'Moderate-Low', 'Moderate', 'Moderate-High', 'Aggressive']} defaultValue={2} onChange={setRiskTolerance} data-id="element-30" />

        <CustomSlider label="Time horizon" options={['< 1 year', '1-3 years', '3-5 years', '5+ years']} defaultValue={3} onChange={setTimeHorizon} data-id="element-31" />
      </div>

      <div className="bg-zinc-950 rounded-lg p-4 border border-zinc-800" data-id="element-32">
        <p className="text-sm text-zinc-300" data-id="element-33">{getVerdict()}</p>
      </div>
    </div>;
}